import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import PreviewTemplate from './pages/PreviewTemplate';

// Públicas
import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import VerifyEmail from './pages/VerifyEmail';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import PublicEvent from './pages/PublicEvent';

// Privadas
import Dashboard from './pages/Dashboard';
import Templates from './pages/Templates';
import CreateEvent from './pages/CreateEvent';
import EventDetail from './pages/EventDetail';

const PrivateLayout = ({ children }) => (
  <ProtectedRoute>
    <Layout>{children}</Layout>
  </ProtectedRoute>
);

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* -------- Públicas -------- */}
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        {/* Invitación pública (sin login) */}
        <Route path="/i/:shortCode" element={<PublicEvent />} />

        {/* Vista previa de plantilla (sin login) */}
        <Route path="/preview/:slug" element={<PreviewTemplate />} />

        {/* -------- Privadas -------- */}
        <Route path="/dashboard" element={<PrivateLayout><Dashboard /></PrivateLayout>} />
        <Route path="/templates" element={<PrivateLayout><Templates /></PrivateLayout>} />
        <Route path="/events/new/:templateId" element={<PrivateLayout><CreateEvent /></PrivateLayout>} />
        <Route path="/events/:id" element={<PrivateLayout><EventDetail /></PrivateLayout>} />

        {/* -------- 404 -------- */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}